import styled from 'styled-components';

import { layout } from '../../../package.json';

interface ProductItemProps {
  width?: number | 195;
  height?: number | 270;
}

export const Root = styled.div`
  margin-bottom: 4px;
  margin-left: 4px;
  /* position: relative; */

  background: #fff;

  @media (max-width: ${layout.mobile}) {
    position: none;
  }
`;

export const Container = styled.a<ProductItemProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 4px 8px 4px;
  flex-direction: column;
  position:relative;
  overflow: hidden;

  text-align: center;
  text-decoration: none;
  color: var(--fontcolor);

  width: 185px;
  height: 310px;

  @media (max-width: ${layout.mobile}) {
    grid-template-columns: 210px 210px;
    max-width: 165px;
    height: 290px;
    padding: 22px 4px 6px 4px;
  }

  &:hover {
    border-color: #a5a5a5;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    z-index: 1000;
    background: #fff;
    
    border: 1px solid var(--primary);
    border-radius: 5px;
    a {
      text-decoration: none;
      color: var(--fontcolor);
    }

    @media (max-width: ${layout.mobile}){
    height: 290px;
    }
  }
`;

export const IconsActions = styled.div`
  position: absolute;  
  top: -5px;
  left: 75%;
//display: fixed;
  //justify-content: flex-end;

  width: 100%;
  padding: 10px 10px;

  svg {
    cursor: pointer;
  }

  /* @media (max-width: ${layout.mobile}) {
    left: 95px;
  } */
`;

export const Image = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 165px;
  }

  @media (max-width: ${layout.mobile}) {
    img {
      width: 100%;
      height: 85%;
      /* height: 90px; */

       &:hover {
        transform: perspective(600px) rotateY(180deg);
      } 
    }
  }
`;

export const Action = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4;
  border: 1px solid #f4f4f4;
  gap: 4px;
  border-radius: 8px;
  height: 28px;
  margin-top: 2px;

  padding: 1px 6px;

  span {
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
  }
  
  input {
    border: 1px solid #f4f4f4;
    border-radius: 8px;
    width: 50px;
    height: 24px;
    background: #fff;
    color: #646464;
    text-align: center;
    font-size: 0.75rem;
  }
  
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
  
  svg {
    font-size: 1.2rem;
  }

  @media (max-width: ${layout.mobile}) {
    height: 26px;
    gap: 3px;
    padding: 1px 4px;
    
    input {
      width: 40px;
      height: 22px;
      font-size: 0.7rem;
    }
    
    span {
      font-size: 0.65rem;
    }
    
    svg {
      font-size: 1.1rem;
    }
  }
`;

export const Botton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 25px;
  margin: 4px 0;
  
  span {
    text-align: center;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.2;
  }

  width: 100%;
  padding: 0 2%;

  @media (max-width: ${layout.mobile}) {
    height: 20px;
    margin: 2px 0;
  }
`;

export const ContentStar = styled.div`
  height: 40px;
  display: flex;
  justify-items: center;
  align-items: center;
`;

export const Amount = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 38px;
  margin: 4px 0;

  .reference-price {
    font-size: 0.7rem;
    color: #666;
    font-weight: 400;
    margin: 5px 0 5px 0;
    text-align: center;
    line-height: 1;
  }

  .dynamic-price {
    font-size: 1.15rem;
    font-weight: 700;
    color: #333;
    text-align: center;
    line-height: 1;

    .unit {
      font-size: 0.8rem;
      font-weight: 400;
      color: #666;
    }
  }

  .single-price {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    text-align: center;
    line-height: 1;

    .unit {
      font-size: 0.8rem;
      font-weight: 400;
      color: #666;
    }
  }

  @media (max-width: ${layout.mobile}) {
    /* height: 32px;
    margin: 2px 0; */

    .reference-price {
      font-size: 0.65rem;
    }

    .dynamic-price {
      font-size: 1rem;

      .unit {
        font-size: 0.7rem;
      }
    }

    .single-price {
      font-size: 0.95rem;

      .unit {
        font-size: 0.7rem;
      }
    }
  }
`;
